import React from "react";
import { Skeleton } from "@shadcn-in-nx/ui/skeleton";

export default function WorkflowListSkeleton({ fullPage = false }) {
    const tableRows = (
        <div className="border rounded-md">
            <div className="p-4">
                <div className="flex items-center gap-4 py-2">
                    <Skeleton className="h-5 w-full" />
                </div>
                {[...Array(5)].map((_, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-4 py-4 border-t"
                    >
                        <Skeleton className="h-5 w-[200px]" />
                        <Skeleton className="h-5 w-[100px]" />
                        <Skeleton className="h-5 w-[80px]" />
                        <Skeleton className="h-5 w-[120px]" />
                        <Skeleton className="h-5 w-[60px]" />
                        <Skeleton className="h-5 w-[80px]" />
                        <Skeleton className="h-8 w-8 ml-auto" />
                    </div>
                ))}
            </div>
        </div>
    );

    if (fullPage) {
        return (
            <div className="space-y-6">
                <div className="flex justify-between items-center">
                    <Skeleton className="h-8 w-[150px]" />
                    <Skeleton className="h-10 w-[150px]" />
                </div>
                <div className="flex items-center justify-between border-b pb-4">
                    <div className="flex items-center gap-2">
                        <Skeleton className="h-9 w-[80px]" />
                        <Skeleton className="h-9 w-[100px]" />
                    </div>
                    <Skeleton className="h-5 w-[120px]" />
                </div>
                <div className="space-y-4">
                    {tableRows}
                    <div className="flex justify-center">
                        <Skeleton className="h-10 w-[300px]" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {tableRows}
            <div className="flex justify-center">
                <Skeleton className="h-10 w-[300px]" />
            </div>
        </div>
    );
}
